import CreativeEditorSDK from '@cesdk/cesdk-js'

type DockOrder = Parameters<CreativeEditorSDK['ui']['setDockOrder']>[0]
const dockOrder: DockOrder = [
  {
    id: 'ly.img.assetLibrary.dock',
    key: 'oneshop-templates-dock-entry',
    label: 'Templates',
    icon: '@imgly/Template',
    entries: ['oneshop-templates-entry'],
  },
  {
    id: 'ly.img.assetLibrary.dock',
    key: 'ly.img.elements',
    icon: '@imgly/Library',
    label: 'component.library.elements',
    entries: ['ly.img.text', 'ly.img.vectorpath', 'ly.img.sticker'],
  },
  {
    id: 'ly.img.assetLibrary.dock',
    key: 'unsplash-dock-entry',
    label: 'Stock Images',
    icon: '@imgly/Image',
    entries: ['unsplash-entry'],
  },
  {
    id: 'ly.img.assetLibrary.dock',
    key: 'products-dock-entry',
    label: 'Products',
    icon: '@imgly/CustomLibrary',
    entries: ['products-entry'],
  },
  {
    id: 'ly.img.assetLibrary.dock',
    key: 'assets-dock-entry',
    label: 'Assets',
    icon: '@imgly/Video',
    entries: ['assets-entry'],
  },
  {
    id: 'ly.img.assetLibrary.dock',
    key: 'ly.img.text',
    icon: '@imgly/Text',
    label: 'libraries.ly.img.text.label',
    entries: ['ly.img.text'],
  },
  {
    id: 'ly.img.assetLibrary.dock',
    key: 'ly.img.vectorpath',
    icon: '@imgly/Shapes',
    label: 'libraries.ly.img.vectorpath.label',
    entries: ['ly.img.vectorpath'],
  },
  {
    id: 'ly.img.assetLibrary.dock',
    key: 'ly.img.sticker',
    icon: '@imgly/Sticker',
    label: 'libraries.ly.img.sticker.label',
    entries: ['ly.img.sticker'],
  },
]

export { dockOrder }
